import React from 'react';
import { FormattedMessage } from 'react-intl';

import SiteCoupons from 'Components/Account/CouponsAndRewards/SiteCoupons';

export default function CouponsAndRewards() {
  return (
    <section className="account-content">
      <h1>
        <FormattedMessage id="account-coupons-rewards.heading" defaultMessage="Coupons & Rewards" />
      </h1>
      <SiteCoupons />
    </section>
  );
}
